import HTTP_EDITION from '../HTTPEdition';

const URL_BASE_EDITION = 'Edition/PrintAsync';
const URL_BASE_EXPORT_EXCEL = 'ExportExcel/ExportAsync';

export async function exportPdf(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const payload = {
      ids: [id],
      extension: 'Pdf',
      typeDonnee: 'Opportunite',
    }
    const response = await HTTP_EDITION.post(URL_BASE_EDITION, payload, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function exportRecapPdf(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const payload = {
      ids: [id],
      extension: 'Pdf',
      typeDonnee: 'OpportuniteRecap',
      typeEdition: 'OpportuniteRecap',
    }
    const response = await HTTP_EDITION.post(URL_BASE_EDITION, payload, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function exportExcel(id) {
  // eslint-disable-next-line no-useless-catch
  try {
    const payload = {
      ids: [id],
      typeDonnee: 'opportunite',
      parametresAdditionnels: { id }
    }
    const response = await HTTP_EDITION.post(URL_BASE_EXPORT_EXCEL, payload, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}
